import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { BaseTemplate } from './BaseTemplate.js';
import $ from 'jquery';
import FontAwesome from 'react-fontawesome';
import { NavLink, Redirect } from 'react-router-dom';

export class GatewayChoose extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      url: 'https://sparkjvm.com/cloud/json',
      api: 'GetDevices',
      devices: '',
      force: props.match.params.force
    };

    this.setChoice = this.setChoice.bind(this);
  }

  componentDidMount() {
    this.getDevices();

    if (this.state.force === undefined) {
      let cookie = this.readCookie('gateway_id');
      if (cookie) {
        this.props.history.push('/devices/device-' + cookie);
      }
    }
  }

  setChoice(device_id) {
    document.cookie = 'gateway_id=' + device_id + ";path=/";
  }

  renderDevices() {
    if (this.state.devices) {
      const listDevices = this.state.devices.map((device) => {
        return(
          <NavLink key={ device.id } to={ '/devices/device-' + device.id } className="devices__el" onClick={ () => { this.setChoice(device.id) } }>
            <div className="devices__el__content">
              <FontAwesome className="" name='cube' />
              <span className="devices__el__content__name">{ device.Description }</span>
              <span className="devices__el__content__status">Stato: { device.Status }</span>
              <span className="devices__el__content__serial">S/N: { device.SerialNumber }</span>
            </div>
          </NavLink>
        );
      });
      return(
        <div className="devices">{ listDevices }</div>
      )
    }
    return '';
  }

  getDevices() {
    $.ajax({
      method: 'POST',
      url: this.state.url,
      headers: {
        'x-session': this.props.token,
      },
      data: JSON.stringify({
        Action: this.state.api
      }),
      xhrFields: {
        withCredentials: true
      },
      dataType: 'JSON',
      success: (res) => {
        if (res.Devices) {
          this.setState({ devices: res.Devices });
        }
      },
      error: (httpReq, status, exception) => {
        this.checkLoginStatus();
      },
    });
  }

  render() {
    return (
      <BaseTemplate>
        <div className="overlay">
          <div className="overlay__shadow"></div>
          <div className="overlay__content overlay__content--padded">
            <h1>Scegli Gateway</h1>
            { this.renderDevices() }
          </div>
        </div>
      </BaseTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GatewayChoose.js